export default function Promos() {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block bg-[#f67f19] text-white px-4 py-2 rounded-full font-bold text-xs md:text-sm mb-4 md:mb-6 uppercase tracking-wide">
            Special Offers
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#535669] mb-3 md:mb-4 leading-tight">
            Limited Time Promotions
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
            Take advantage of our exclusive offers and save on quality electrical services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Promo 1 - $50 OFF First Job (orange) */}
          <div className="bg-gradient-to-br from-[#f67f19] to-[#e06e0a] rounded-2xl p-6 md:p-10 text-white shadow-xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 md:w-40 md:h-40 bg-white/10 rounded-full -mr-16 -mt-16 md:-mr-20 md:-mt-20"></div>
            <div className="relative z-10">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-white/20 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-price-tag-3-fill text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-2 md:mb-3">$50 OFF</h3>
              <p className="text-base md:text-lg mb-4 md:mb-6 text-white/90">
                Get $50 off your first job — new customers only
              </p>
              <div className="inline-block bg-white text-[#f67f19] px-4 py-2 rounded-full font-bold text-xs md:text-sm">
                New Customers Only
              </div>
            </div>
          </div>

          {/* Promo 2 - Free Call Out (dark) */}
          <div className="bg-gradient-to-br from-[#535669] to-[#3d3f4d] rounded-2xl p-6 md:p-10 text-white shadow-xl relative overflow-hidden">
            <div className="absolute bottom-0 left-0 w-32 h-32 md:w-40 md:h-40 bg-[#f67f19]/20 rounded-full -ml-16 -mb-16 md:-ml-20 md:-mb-20"></div>
            <div className="relative z-10">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19]/20 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-car-fill text-2xl md:text-3xl text-[#f67f19]"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-2 md:mb-3">Free Call Out</h3>
              <p className="text-base md:text-lg mb-4 md:mb-6 text-white/90">
                No call out fee — we come to you at no extra charge
              </p>
              <div className="inline-block bg-[#f67f19] text-white px-4 py-2 rounded-full font-bold text-xs md:text-sm">
                No Hidden Fees
              </div>
            </div>
          </div>

          {/* Promo 3 - 20% Pensioners Discount (orange) */}
          <div className="bg-gradient-to-br from-[#f67f19] to-[#e06e0a] rounded-2xl p-6 md:p-10 text-white shadow-xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 md:w-40 md:h-40 bg-white/10 rounded-full -mr-16 -mt-16 md:-mr-20 md:-mt-20"></div>
            <div className="relative z-10">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-white/20 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-heart-fill text-2xl md:text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-2 md:mb-3">20% OFF</h3>
              <p className="text-base md:text-lg mb-4 md:mb-6 text-white/90">
                Pensioners discount — 20% off all electrical services
              </p>
              <div className="inline-block bg-white text-[#f67f19] px-4 py-2 rounded-full font-bold text-xs md:text-sm">
                Pensioners Discount
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
